import React, { useEffect, useState } from 'react'

import {
  Box,
  Card,
  FormControlLabel,
  Radio,
  RadioGroup,
  Switch,
  Typography,
} from '@material-ui/core'

import PublicLinkBanner from 'views/TrainingCourses/components/PublicLinkBanner'

import useStyles from './styles'
import courseConstants from 'constants/courseAccess'

const AccessTypeCard = ({
  isEdit,
  accessType,
  loginMode,
  setValue,
  courseId,
}) => {
  const classes = useStyles()

  const [isPublicLink, setIsPublicLink] = useState(false)

  const { ACCESS_TYPES, LOGIN_MODES } = courseConstants

  useEffect(() => {
    setIsPublicLink(accessType === ACCESS_TYPES.PUBLIC_LINK)
  }, [accessType])

  const handleAccessTypeToggle = (event) => {
    const checked = event.target.checked
    setIsPublicLink(checked)
    setValue(
      'accessType',
      checked ? ACCESS_TYPES.PUBLIC_LINK : ACCESS_TYPES.PRIVATE_ACCESS,
    )
    if (!checked) setValue('loginMode', LOGIN_MODES.TWO_FACTOR_EMAIL)
  }

  return (
    <Card className={classes.section}>
      <Typography variant="h5" className={classes.sectionTitle}>
        Login
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Alunos já cadastrados no curso acessam normalmente com telefone ou
        e-mail. Ativar a opção abaixo permite o autocadastro, para que o próprio
        aluno se matricule sem precisar da liberação de um gestor.
      </Typography>
      <Box className={classes.emphasisColor} p={2}>
        <Box className={classes.inlineBox}>
          <Box>
            <Typography variant="body2">Acesso por link público</Typography>
            <Typography variant="body2" color="textSecondary">
              Quando ativado, qualquer pessoa com o link pode acessar o portal.
            </Typography>
          </Box>
          <FormControlLabel
            className={classes.switchLabel}
            control={
              <Switch
                disabled={!isEdit}
                checked={isPublicLink}
                onChange={handleAccessTypeToggle}
                color="primary"
              />
            }
          />
        </Box>
      </Box>
      {isPublicLink && (
        <Box className={classes.emphasisColor} p={2}>
          <Box mt={2}>
            <Typography variant="body2">
              Modo de identificação do aluno
            </Typography>
            <RadioGroup
              className={classes.radioGroup}
              value={loginMode || LOGIN_MODES.TWO_FACTOR_EMAIL}
              onChange={(event) => setValue('loginMode', event.target.value)}
            >
              <FormControlLabel
                disabled={!isEdit}
                value={LOGIN_MODES.TWO_FACTOR_EMAIL}
                control={<Radio color="primary" />}
                label="Cadastro utilizando e-mail"
              />
              <FormControlLabel
                disabled={!isEdit}
                value={LOGIN_MODES.TWO_FACTOR_PHONE}
                control={<Radio color="primary" />}
                label="Cadastro utilizando telefone"
              />
            </RadioGroup>
          </Box>
          <PublicLinkBanner courseId={courseId} />
        </Box>
      )}
    </Card>
  )
}

export default AccessTypeCard
